import{css as o,variants as r,modifier as e,styled as c}from"@lokalise/styled";import{color as a,spacing as n,transitionTime as i,radius as t}from"../../utils/theme/index.js";import{Pressable as d}from"../Pressable/index.js";const l=o`
	${r("appearance",{primary:o`
			padding: 6px;
			font-size: 20px;

			// hover
			&:hover:not([disabled]) {
				background-color: ${a("surface.primary100")};
				color: ${a("primary.500")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${a("primary.200")};
				color: ${a("primary.500")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${a("surface.primary50")};
				color: ${a("primary.500")};
			}

			// activated
			${e("active",o`
					background-color: ${a("surface.primary50")};
					color: ${a("primary.500")};
				`)}
		`,secondary:o`
			padding: ${n(1)};
			font-size: 16px;
			color: ${a("content.secondary")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${a("border.secondary")};
				color: ${a("content.primary")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${a("border.primary")};
				color: ${a("content.primary")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${a("surface.secondary")};
				color: ${a("content.primary")};
			}

			// activated
			${e("active",o`
					background-color: ${a("surface.secondary")};
					color: ${a("content.primary")};
				`)}
		`,verified:o`
			padding: ${n(1)};
			font-size: 16px;
			color: ${a("content.secondary")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${a("surface.yellow100")};
				color: ${a("content.primary")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${a("yellow.200")};
				color: ${a("content.primary")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${a("surface.yellow100")};
				color: ${a("content.primary")};
			}

			// activated
			${e("active",o`
					background-color: ${a("surface.yellow50")};
					color: ${a("content.primary")};
				`)}
		`,reviewed:o`
			padding: ${n(1)};
			font-size: 16px;
			color: ${a("content.secondary")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${a("surface.green100")};
				color: ${a("content.primary")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${a("green.200")};
				color: ${a("content.primary")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${a("surface.green100")};
				color: ${a("content.primary")};
			}

			// activated
			${e("active",o`
					background-color: ${a("surface.green50")};
					color: ${a("content.primary")};
				`)}
		`})}
`,s=c(d).withConfig({displayName:"IconButton__Container",componentId:"sc-1cxbr1d-0"})(["display:inline-flex;align-items:center;background-color:transparent;color:",";transition:background-color ",",color ",";border:0;border-radius:",";text-decoration:none;"," &:disabled{cursor:not-allowed;color:",";","}"],a("content.primary"),i(),i(),t("md"),l,a("interactive.primary.disabled"),e("isLoading",o`
				color: initial;
				cursor: auto;
				${l}
			`));export{s as Container};
//# sourceMappingURL=styles.js.map
